<template>
  <b-container>
    <b-row>
      <b-col>
        <form-signup-request class="my-4 my-lg-5">
          <template #header>
            <div class="text-center">
              <router-link :to="{ name: 'Home' }" class="mb-4 mx-auto d-table">
                <img
                  src="@assets/img/logo-lg--colored.png"
                  alt="LimeIQ"
                  class="form-logo"
                  width="401"
                  height="120"
                />
              </router-link>
              <h2>Request Access</h2>
              <p class="small">
                Fill up the form or contact your company admin first to create
                your account
              </p>
            </div>
          </template>
        </form-signup-request>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import { AuthenticationService } from '@services'

import FormSignupRequest from '@components/FormSignupRequest'

export default defineComponent({
  name: 'RequestSignUpPage',
  components: {
    FormSignupRequest
  },
  beforeRouteEnter(to, from, next) {
    const requestAccessEmail = AuthenticationService.requestAccessEmail

    if (!requestAccessEmail) next({ name: 'Home' })
    else next()
  }
})
</script>
